import { render, staticRenderFns } from "./Merchant.vue?vue&type=template&id=486e0b9a&scoped=true&"
import script from "./Merchant.vue?vue&type=script&lang=js&"
export * from "./Merchant.vue?vue&type=script&lang=js&"
import style0 from "./Merchant.vue?vue&type=style&index=0&id=486e0b9a&scoped=true&lang=css&"
import style1 from "./Merchant.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486e0b9a",
  null
  
)

export default component.exports